var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChinese(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#D80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37812 4.86865L5.06875 6.99365H7.30312L5.49687 8.30928L6.1875 10.4343L4.37812 9.12178L2.56875 10.4343L3.2625 8.30928L1.45312 6.99365H3.6875L4.37812 4.86865Z",
    fill: "#FFDA44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48447 12.3906L8.95635 11.7406L8.1751 12.0437L8.62822 11.3406L8.1001 10.6875L8.90947 10.9031L9.36572 10.2L9.40947 11.0375L10.222 11.2531L9.4376 11.5531L9.48447 12.3906Z",
    fill: "#FFDA44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5345 10.4843L10.7845 9.68433L10.1001 9.19995L10.9376 9.18745L11.1845 8.38745L11.4563 9.1812L12.2938 9.17183L11.622 9.67183L11.8907 10.4656L11.2063 9.9812L10.5345 10.4843Z",
    fill: "#FFDA44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9499 5.87185L11.5812 6.62498L12.1812 7.20935L11.353 7.0906L10.9843 7.8406L10.8405 7.0156L10.0093 6.89685L10.753 6.50623L10.6093 5.6781L11.2093 6.26248L11.9499 5.87185Z",
    fill: "#FFDA44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5062 3.59058L9.4437 4.42495L10.2218 4.74058L9.4062 4.94058L9.34683 5.77808L8.9062 5.06558L8.09058 5.26558L8.6312 4.62495L8.18745 3.91558L8.96558 4.2312L9.5062 3.59058Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChinese);
export default __webpack_public_path__ + "static/media/chinese.ed910d7982d8b9cbdb3ae3c004c88373.svg";
export { ForwardRef as ReactComponent };